<div *ngIf="committeeStatus !== undefined">
    <app-status-badge [colourScheme]="badgeColourScheme" [name]="name">
        {{ committeeStatus }}
    </app-status-badge>
</div>


